import React from 'react';

function ResourceLinks(resourceLinks:any, title:string) {
  if (resourceLinks) {
    return (
      <div className="flex-col justify-start my-4">
        <p className="font-bold text-[24px] tracking-[0.15em] leading-[26.5px] uppercase text-chdGreen-light mb-2 ">{title}</p>
        <div
          className="capitalize text-[16px] !resource-link  opacity-90}"
          dangerouslySetInnerHTML={{ __html: resourceLinks?.childMarkdownRemark.html }}
        />
      </div>
    );
  }
  return null;
}

export default ResourceLinks;
